export default __webpack_public_path__ + "images/models/a6b74a4367a847bf66277765baa8f5e3.glb";